@let event = streappEvent();
@if (event) {
<div class="media-upload-container">
    @if(this.edit()) {
        <div class="existing-media-container">
            <h2>{{ "event_steps.step_media_edit.title" | translate }}</h2>
            <image-carousel [mediaItemArray]="event.mediaItems" />
        </div>
    }

    <div class="media-upload-container">
        <h2>{{ "event_steps.step_media_upload.streapp_title" | translate }}</h2>
        <div class="upload-field-with-description">
            <!-- File drop veld -->
            <div class="upload-field">
                <ngx-file-drop (onFileDrop)="dropped($event, 'none')" [multiple]="true"
                    [accept]="allowedVideoExtensions + ',' + allowedImageExtensions" class="size-m file-drop"
                    [disabled]="event.preUploadedMediaItems.length >= 10">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                        <div class="file-selector" (click)="openFileSelector()">
                            <span class="upload-field-text">{{
                                "event_steps.step_media_upload.dropzone_label" | translate
                                }}</span>
                            <mat-icon>cloud_upload</mat-icon>
                        </div>
                    </ng-template>
                </ngx-file-drop>
                <!-- File counter with maximum of 10 files -->
                <div class="totalFilesUploaded">
                    {{ event.preUploadedMediaItems.length }} / 10
                </div>
            </div>
            <div class="uploadDescriptionField">
                {{
                "event_steps.step_media_upload.upload_description" | translate
                }}
            </div>
        </div>
        <!-- Image file preview -->
        <div class="preview-holder">
            @for (item of [].constructor(10); track $index; let i = $index) {
            <div class="preview">
                @if (event.preUploadedMediaItems[i]) {
                <img class="preview-image-holder" [src]="event.preUploadedMediaItems[i].previewFile"
                    onerror="this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"
                    alt="uploaded-image" />
                <div class="darkenImage"></div>
                <span class="remove-item" typeof="button" (click)="removeFile(i, 'none')"
                    [title]="'general.remove' | translate | titlecase">
                    <mat-icon>delete</mat-icon>
                </span>
                }
                @if (!event?.preUploadedMediaItems[i]) {
                <img class="preview-image-holder-empty" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" />
                }
            </div>
            }
        </div>
    </div>
    <!-- Filepreview Holders Shop-only -->
    @if (authService.isStreapper) {
        <div class="shop-only-media-upload-container">
            <h2 class="shop-only-content-title">
                {{ "event_steps.step_media_upload.shop_only_title" | translate }}
            </h2>
            <div class="upload-field-with-description">
                <!-- File drop veld -->
                <div class="upload-field">
                    @if (event.linkedToMainStreappID) {
                    <div class="image-description" [innerHTML]="'event_steps.step_media_upload.description_comment' | translate"></div>
                    }
                    <ngx-file-drop (onFileDrop)="dropped($event, 'shop')" [multiple]="true"
                        [accept]="allowedVideoExtensions + ',' + allowedImageExtensions" class="size-m file-drop"
                        [disabled]="event.preUploadedShopMediaItems.length >= 10">
                        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                            <div class="file-selector" (click)="openFileSelector()">
                                <span class="upload-field-text">{{
                                    "event_steps.step_media_upload.dropzone_label" | translate
                                    }}</span>
                                <mat-icon>cloud_upload</mat-icon>
                            </div>
                        </ng-template>
                    </ngx-file-drop>
                    <!-- File counter with maximum of 10 files -->
                    <div class="totalFilesUploaded">
                        {{ event.preUploadedShopMediaItems.length }} / 10
                    </div>
                </div>
                <div class="uploadDescriptionField">
                    {{
                    "event_steps.step_media_upload.upload_description_shop" | translate
                    }}
                </div>
            </div>
            <div class="preview-content">
                <div class="preview-holder">
                    @for (item of [].constructor(10); track $index; let i = $index) {
                    <div class="preview">
                        @if (event.preUploadedShopMediaItems[i]) {
                        <img class="preview-image-holder" [src]="event.preUploadedShopMediaItems[i].previewFile"
                            onerror="this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"
                            alt="uploaded-image" />
                        <div class="darkenImage"></div>
                        <span class="remove-item" typeof="button" (click)="removeFile(i, 'shop')"
                            [title]="'general.remove' | translate | titlecase">
                            <mat-icon>delete</mat-icon>
                        </span>
                        }
                        @if (!event.preUploadedShopMediaItems[i]) {
                        <img class="preview-image-holder-empty"
                            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" />

                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    }
</div>
}